// extracted by mini-css-extract-plugin
module.exports = {"form":"styles_form__3nRV4","row":"styles_row__w5xnn"};